import { AiTool } from 'core/services/admin.service';
import { ToolRecord, ParamRecord, PromptRecord } from './admin.types';

export function findLinkedPrompts(toolName: string, prompts: PromptRecord[]): string[] {
  const linked: string[] = [];
  for (const p of prompts) {
    const body = String(p.body || '');
    if (body.includes(toolName)) {
      linked.push(p.name);
    }
  }
  return linked;
}

export function mapAiToolToToolRecord(tool: AiTool, prompts?: PromptRecord[]): ToolRecord {
  const name = String(tool.name || '');
  const titleFromName = name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  const updatedAt = tool.updatedAt ? String(tool.updatedAt) : '';
  const updatedLabel = updatedAt ? new Date(updatedAt).toLocaleString() : '';
  const status = tool.enabled ? 'published' : 'draft';

  // Extract params from inputSchema.properties
  const schemaProps = (tool.inputSchema && typeof tool.inputSchema === 'object'
    ? (tool.inputSchema as Record<string, unknown>).properties
    : null) as Record<string, Record<string, unknown>> | null;
  const requiredArr = (tool.inputSchema && typeof tool.inputSchema === 'object'
    ? (tool.inputSchema as Record<string, unknown>).required
    : []) as string[] | undefined;
  const requiredSet = new Set(requiredArr || []);

  const params: ParamRecord[] = schemaProps
    ? Object.entries(schemaProps).map(([paramName, prop]) => ({
        name: paramName,
        type: String(prop.type || 'string'),
        required: requiredSet.has(paramName),
        desc: String(prop.description || ''),
        example: prop.example != null ? String(prop.example) : undefined,
      }))
    : [];

  // Build sample input from params
  const sampleInput: Record<string, string> = {};
  for (const p of params) {
    sampleInput[p.name] = p.example || '';
  }
  const exampleIn = JSON.stringify(sampleInput, null, 2);

  return {
    id: tool.id,
    name,
    title: titleFromName,
    description: String(tool.description || ''),
    status,
    version: 1,
    updated: updatedLabel,
    owner: 'admin',
    runtime: tool.type || 'handler',
    params,
    returns: 'object',
    examples: [{ in: exampleIn, out: '{}' }],
    linkedPrompts: prompts ? findLinkedPrompts(name, prompts) : [],
    toolType: tool.type,
    aiToolId: tool.id,
  };
}
